import { render, staticRenderFns } from "./QuantidadeProduto.vue?vue&type=template&id=12100e8b&scoped=true"
import script from "./QuantidadeProduto.vue?vue&type=script&lang=js"
export * from "./QuantidadeProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12100e8b",
  null
  
)

export default component.exports